/**
 * Created by jiachenpan on 16/11/18.
 */

import store from '../store'
import request from '@/util/request'

// import { findDdItme } from '@/api/dataDic'
// << 自己的
// 发送数据，表单形式
export function requestForm(url, method, data) {
  return request({
    url: url,
    method,
    headers: { "Content-Type": "multipart/form-data" },

    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      ret = ret.substr(0, ret.length - 1)
      return ret
    }],
    data
  })
}
// 上传excel 发送数据
export function requestExcel(url, data) {
  let formData = new FormData()
  for (let key in data) {
    let value = data[key]
    formData.append(key, value)
  }
  console.log('dddd', formData)

  return request({
    url,
    method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
    data: formData
  })
}
// 数字小于10，前面补零
export let return2Num = num => {
  if (num < 10) {
    num = '0' + num
  }
  return num
}
// 返回汉字 星期
export function num2week(num) {
  let week = '';
  switch (num) {
    case '0':
      week = '周日'
      break;
    case '1':
      week = '周一'
      break;
    case '2':
      week = '周二'
      break;
    case '3':
      week = '周三'
      break;
    case '4':
      week = '周四'
      break;
    case '5':
      week = '周五'
      break;
    case '6':
      week = '周六'
      break;
  }
  return week
}
// 获取数据字典数据
export function getSjzd(scope, groupChar, key) {
  let sendObj = {
    groupChar,
    page: 1,
    size: 500
  }
  findDdItme(sendObj).then(res => {
    let list = res.data.list

    let newArr = []
    for (let item of list) {
      let newObj = {
        id: item.itemValue + '',
        name: item.itemText
      }
      newArr.push(newObj)
    }
    scope[key] = newArr.reverse()
  })
}
// 从数据字典中 根据 ID 返回 文字
export function arrId2Name(arr, id) {
  for (let item of arr) {
    if (item.id === id) {
      return item.name
    }
  }
}
// 从数组中 根据 ID 返回 文字, 数组，id值，id对应字段，name对应字段
export function arrId2Name2(arr, id, idText, nameText) {
  for (let item of arr) {
    if (item[idText] === id) {
      return item[nameText]
    }
  }
}
// 计算时间差，并保留小数点后一位
export function dateReduce(dateArr) {
  let start = new Date(dateArr[0])
  let end = new Date(dateArr[1])
  let timeReduce = end - start
  timeReduce = timeReduce / 24 / 60 / 60 / 1000
  timeReduce = (Math.round(timeReduce * 10)) / 10
  return timeReduce
}
// 计算小时数
export function reduce2Xs(dateArr) {
  let start = new Date(dateArr[0])
  let end = new Date(dateArr[1])
  let timeReduce = end - start
  timeReduce = parseInt(timeReduce / 60 / 60 / 1000)
  return timeReduce
}
// 修改 store 中的状态，先清空(aaa，vue组件内，watch 需判断值是否为aaa)，再赋值，解决组件值不存在问题
export function myCommit(commitKey, commitVal) {
  store.commit(commitKey, 'aaa')
  setTimeout(() => {
    store.commit(commitKey, commitVal)
  }, 100)
}
// 返回当前月份
export function backMonthNow() {
  let dateObj = new Date()
  let month = dateObj.getFullYear() + '-' + return2Num(dateObj.getMonth() + 1)
  return month
}
// 设置首页顶部banner高度
export function getIndexTopH() {
  let winW = $(window).width()
  let bannerH = (winW / 1920) * 660
  return bannerH
}

// >> 自己的
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}
// 判断是否为空
export function isNull(data) {
  return data === "" || data === undefined || data === null;
}




// WEBPACK FOOTER //
// ./src/util/index.js